import GenericStore from '../classes/generic-store';
import { AccountModel } from '../models/account';
import { removeContactFromAccount } from '../api/accounts-legacy-api';
import { getAccount } from '../api/accounts-api';

class AccountStoreClass extends GenericStore {
  async load(id) {
    return this.setState(getAccount(id));
  }

  removeContactFromAccount(contactId, accountId) {
    return removeContactFromAccount({ accountId, contactId }).then(() => {
      this.load(accountId);
    });
  }

  getDataShape() {
    return AccountModel;
  }
}

export const AccountStore = new AccountStoreClass();
